import { PAYER_COLOR_COMBOS } from '@/utils/payerLogoColors';

/**
 * Generate consistent color combination based on payer name
 * Uses a hash function to ensure the same payer always gets the same colors
 */
export const getPayerColorCombo = (payerName: string) => {
  // Simple hash function to convert string to number
  let hash = 0;
  for (let i = 0; i < payerName.length; i++) {
    const char = payerName.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash = hash & hash; // Convert to 32-bit integer
  }

  // Use absolute value and modulo to get index
  const index = Math.abs(hash) % PAYER_COLOR_COMBOS.length;
  return PAYER_COLOR_COMBOS[index];
};
